import { COLORS } from 'helpers/globals'

export default {
  container: {
    display: 'flex',
    flex: '1 1 auto'
  },
  showDropdown: {
    fontSize: '1.3rem',
    zIndex: 10,
    position: 'absolute',
    padding: '.5rem',
    background: 'white',
    border: `1px solid ${COLORS.quaternary}`,
    paddingRight: '2rem',
    marginTop: 28
  },
  hideDropdown: {
    display: 'none'
  },
  exportButton: {
    margin: '0 1.25rem 0 0',
    color: COLORS.primary,
    border: 0,
    padding: 0,
    fontSize: '1.3rem',
    '&:hover': {
      color: COLORS.secondary
    }
  },
  exportIcon: {
    fontSize: '1.5rem',
    marginRight: 3
  },
  caretDownIcon: {
    fontSize: '1.5rem',
    marginLeft: 3
  },
  exportProgress: {
    display: 'inline-block',
    '& span': { marginRight: '1rem' }
  },
  dropdownItem: {
    color: COLORS.primary,
    cursor: 'pointer',
    marginBottom: '.5rem',
    verticalAlign: 'middle',
    '&:last-of-type': {
      marginBottom: 0
    },
    '&:hover': { color: COLORS.secondary }
  },
  dropdownIcon: {
    marginRight: '.4rem',
    fontSize: '2rem',
    width: 20
  },
  snapshotDropdownIcon: {
    marginRight: '.4rem',
    marginBottom: -3,
    fontSize: '2rem',
    width: 20
  },
  addButtonIcon: {
    marginRight: '.3rem',
    fontSize: '1.5rem'
  },
  addFloorPlanButton: {
    cursor: 'pointer',
    color: COLORS.primary,
    fontSize: '1.3rem',
    margin: '0 1.25rem 0 0',
    '&:hover': { color: COLORS.secondary }
  }
}



// WEBPACK FOOTER //
// ./src/components/TopBar/ExportDropdown/style.js